module.exports = __webpack_public_path__ + "img/tcCfMn2JStiEAl5fEqTk70Is9ZO3V7D5.a3a224fd.png";